// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "decco/src/Decco.bs.mjs";
import * as React from "react";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Js_json from "rescript/lib/es6/js_json.js";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Js_array from "rescript/lib/es6/js_array.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as CSS$MakerDs from "maker-ds/src/CSS.bs.mjs";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Themes from "@clerk/themes";
import * as ClerkReact from "@clerk/clerk-react";

var ProviderImpl = {};

var SignedIn = {};

var SignedOut = {};

var SignIn = {};

var SignUp = {};

var CreateOrganization = {};

var UserProfile = {};

var UserButton = {};

var OrganizationSwitcher = {};

function organizationPublicMetadata_encode(v) {
  return Js_dict.fromArray([[
                "accountId",
                Decco.optionToJson(Decco.stringToJson, v.accountId)
              ]]);
}

function organizationPublicMetadata_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var accountId = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict._0, "accountId"), null));
  if (accountId.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              accountId: accountId._0
            }
          };
  }
  var e = accountId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".accountId" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function organization_encode(v) {
  return Js_dict.fromArray([
              [
                "id",
                Decco.stringToJson(v.id)
              ],
              [
                "publicMetadata",
                organizationPublicMetadata_encode(v.publicMetadata)
              ],
              [
                "name",
                Decco.optionToJson(Decco.stringToJson, v.name)
              ]
            ]);
}

function organization_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var publicMetadata = organizationPublicMetadata_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "publicMetadata"), null));
    if (publicMetadata.TAG === /* Ok */0) {
      var name = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
      if (name.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  id: id._0,
                  publicMetadata: publicMetadata._0,
                  name: name._0
                }
              };
      }
      var e = name._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".name" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = publicMetadata._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".publicMetadata" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function memberRole_encode(v) {
  if (v === "admin") {
    return ["admin"];
  } else {
    return ["basic_member"];
  }
}

function memberRole_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a polyvariant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a polyvariant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected polyvariant, found empty array", v);
  }
  var tagged = Js_array.map(Js_json.classify, jsonArr$1);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "admin" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to polyvariant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: "admin"
                  };
          }
      case "basic_member" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to polyvariant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: "basic_member"
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid polyvariant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function membership_encode(v) {
  return Js_dict.fromArray([[
                "role",
                memberRole_encode(v.role)
              ]]);
}

function membership_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var role = memberRole_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "role"), null));
  if (role.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              role: role._0
            }
          };
  }
  var e = role._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".role" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

var Global = {
  organizationPublicMetadata_encode: organizationPublicMetadata_encode,
  organizationPublicMetadata_decode: organizationPublicMetadata_decode,
  organization_encode: organization_encode,
  organization_decode: organization_decode,
  memberRole_encode: memberRole_encode,
  memberRole_decode: memberRole_decode,
  membership_encode: membership_encode,
  membership_decode: membership_decode
};

function getOrganization(param) {
  return Belt_Option.flatMap(Belt_Option.map(window.Clerk, (function (prim) {
                    return prim.organization;
                  })), (function (prim) {
                if (prim == null) {
                  return ;
                } else {
                  return Caml_option.some(prim);
                }
              }));
}

function useOrganization(param) {
  try {
    return ClerkReact.useOrganization();
  }
  catch (exn){
    return {
            organization: null,
            membership: null,
            isLoaded: true
          };
  }
}

function getClerkUser(param) {
  return Belt_Option.flatMap(Belt_Option.map(window.Clerk, (function (prim) {
                    return prim.user;
                  })), (function (prim) {
                if (prim == null) {
                  return ;
                } else {
                  return Caml_option.some(prim);
                }
              }));
}

function getPrimaryEmail(param) {
  return Belt_Option.map(Belt_Option.map(getClerkUser(undefined), (function (prim) {
                    return prim.primaryEmailAddress;
                  })), (function (email) {
                return email.emailAddress;
              }));
}

function getUserDisplayName(param) {
  return Belt_Option.orElse(Belt_Option.flatMap(getClerkUser(undefined), (function (user) {
                    var firstName = Belt_Option.getWithDefault(Caml_option.nullable_to_opt(user.firstName), "");
                    var lastName = Belt_Option.getWithDefault(Caml_option.nullable_to_opt(user.lastName), "");
                    var displayName = [
                          firstName,
                          lastName
                        ].join(" ").trim();
                    if (displayName === "") {
                      return ;
                    } else {
                      return displayName;
                    }
                  })), getPrimaryEmail(undefined));
}

function getPublicMetadata(param) {
  return Belt_Option.flatMap(Belt_Option.map(Belt_Option.flatMap(Belt_Option.map(window.Clerk, (function (prim) {
                            return prim.user;
                          })), (function (prim) {
                        if (prim == null) {
                          return ;
                        } else {
                          return Caml_option.some(prim);
                        }
                      })), (function (prim) {
                    return prim.publicMetadata;
                  })), (function (prim) {
                if (prim == null) {
                  return ;
                } else {
                  return Caml_option.some(prim);
                }
              }));
}

function isSuperUser(param) {
  return Belt_Option.getWithDefault(Belt_Option.flatMap(Belt_Option.map(getPublicMetadata(undefined), (function (prim) {
                        return prim.superUser;
                      })), (function (prim) {
                    if (prim == null) {
                      return ;
                    } else {
                      return Caml_option.some(prim);
                    }
                  })), false);
}

function isCustomerSupport(param) {
  var checkByEditorName = Caml_obj.equal(window.ENV.editorName, "Customer Support");
  var match = window.ENV.token;
  var checkByClerkUser = match === "use_clerk" ? isSuperUser(undefined) || Belt_Option.getWithDefault(Belt_Option.flatMap(Belt_Option.map(getPublicMetadata(undefined), (function (prim) {
                    return prim.customerSupport;
                  })), (function (prim) {
                if (prim == null) {
                  return ;
                } else {
                  return Caml_option.some(prim);
                }
              })), false) : false;
  if (checkByEditorName) {
    return true;
  } else {
    return checkByClerkUser;
  }
}

function isMakerEmployee(param) {
  return Belt_Option.mapWithDefault(getPrimaryEmail(undefined), false, (function (email) {
                return email.endsWith("@maker.co");
              }));
}

function getTiktokExternalProvider(user) {
  return Belt_Array.getBy(user.externalAccounts, (function (account) {
                return account.provider === "tiktok";
              }));
}

var tiktokAdditonalScopes = [
  "user.info.basic",
  "user.info.profile",
  "user.info.stats",
  "video.list"
];

function getClerkUserId(account, param) {
  var match = getClerkUser(undefined);
  var match$1 = Belt_Option.flatMap(account, (function (a) {
          return a.clerkOrganizationId;
        }));
  if (match !== undefined && match$1 !== undefined) {
    return match.id;
  }
  
}

function getClerkInstagramUserId(account, param) {
  var igAccount = Belt_Option.flatMap(account, (function (a) {
          return a.connectedInstagramAccount;
        }));
  if (igAccount !== undefined) {
    return igAccount.adminClerkId;
  }
  
}

var darkAppearance = {
  baseTheme: Themes.dark,
  variables: {
    colorPrimary: "#fff",
    colorTextOnPrimaryBackground: "#fff",
    colorTextSecondary: "#fff"
  },
  elements: {
    rootBox: CSS$MakerDs.prefix("max-w-full"),
    card: CSS$MakerDs.prefix("max-w-full text-white bg-transparent px-2"),
    logoBox: CSS$MakerDs.prefix("hidden"),
    socialButtonsBlockButton: CSS$MakerDs.prefix("bg-white text-black pl-14 py-6 rounded-full"),
    socialButtonsBlockButtonText: CSS$MakerDs.prefix("text-xl font-medium"),
    formFieldLabel: CSS$MakerDs.prefix("text-white text-base font-medium"),
    formFieldInput: CSS$MakerDs.prefix("bg-transparent border border-white rounded-full p-6 text-white text-base"),
    formButtonPrimary: CSS$MakerDs.prefix("w-full text-black text-xl font-medium bg-white p-6 rounded-full"),
    dividerText: CSS$MakerDs.prefix("text-xl font-medium uppercase bg-black px-2"),
    dividerLine: CSS$MakerDs.prefix("bg-white"),
    footer: CSS$MakerDs.prefix("justify-center"),
    footerActionText: CSS$MakerDs.prefix("text-base font-medium"),
    footerActionLink: CSS$MakerDs.prefix("text-base font-medium underline"),
    formFieldErrorText: CSS$MakerDs.prefix("flex items-center justify-center w-full text-sm pt-2"),
    formHeaderTitle: CSS$MakerDs.prefix("text-white"),
    formHeaderSubtitle: CSS$MakerDs.prefix("text-base"),
    formResendCodeLink: CSS$MakerDs.prefix("w-full flex-base text-white underline"),
    identityPreview: CSS$MakerDs.prefix("w-full max-w-full flex justify-center"),
    identityPreviewText: CSS$MakerDs.prefix("text-base"),
    avatarBox: CSS$MakerDs.prefix("bg-white"),
    headerTitle: {
      color: "#fff",
      fontSize: "32px !important",
      fontWeight: "500"
    },
    headerSubtitle: {
      fontSize: "1rem !important"
    },
    socialButtonsBlockButtonArrow: {
      display: "none !important"
    },
    otpCodeFieldInputs: CSS$MakerDs.prefix("flex justify-center my-6"),
    otpCodeFieldInput: CSS$MakerDs.prefix("border border-white rounded"),
    avatarBox: CSS$MakerDs.prefix("border border-white")
  }
};

function Clerk$Provider(Props) {
  var children = Props.children;
  return React.createElement(ClerkReact.ClerkProvider, {
              publishableKey: window.ENV.clerkPublishableKey,
              appearance: {
                layout: {
                  socialButtonsVariant: "blockButton"
                }
              },
              children: null
            }, React.createElement("style", undefined, "\n        html {\n          --maker-font-family: Inter var, Helvetica, sans-serif;\n        }\n      "), children);
}

var Provider = {
  make: Clerk$Provider
};

function waitForClerk(retriesOpt, param) {
  var retries = retriesOpt !== undefined ? retriesOpt : 0;
  var ready = Belt_Option.mapWithDefault(window.Clerk, false, (function (prim) {
          return prim.isReady();
        }));
  var match = retries > 100;
  if (ready || match) {
    return Promise.resolve(undefined);
  } else {
    return new Promise((function (resolve, param) {
                  setTimeout((function (param) {
                          waitForClerk(retries + 1 | 0, undefined).then(function (param) {
                                resolve(undefined);
                              });
                        }), 42);
                }));
  }
}

var $$CSS;

export {
  $$CSS ,
  ProviderImpl ,
  SignedIn ,
  SignedOut ,
  SignIn ,
  SignUp ,
  CreateOrganization ,
  UserProfile ,
  UserButton ,
  OrganizationSwitcher ,
  Global ,
  getOrganization ,
  useOrganization ,
  getClerkUser ,
  getPrimaryEmail ,
  getUserDisplayName ,
  getPublicMetadata ,
  isSuperUser ,
  isCustomerSupport ,
  isMakerEmployee ,
  getTiktokExternalProvider ,
  tiktokAdditonalScopes ,
  getClerkUserId ,
  getClerkInstagramUserId ,
  darkAppearance ,
  Provider ,
  waitForClerk ,
}
/* darkAppearance Not a pure module */
